<template>
    <div
        class="flex flex-wrap justify-center gap-1"
        :class="isFullscreen ? 'max-w-[360px]' : 'max-w-[200px]'"
        aria-hidden="true"
    >
        <span
            v-for="(card, index) in cards"
            :key="card.id || index"
            class="study-dot h-1.5 w-1.5 rounded-full transition-transform"
            :class="dotClass(card, index)"
            :style="index === currentIndex ? 'transform: scale(1.4)' : null"
        ></span>
    </div>
</template>

<script>
'use strict';

export default {
    name: 'FlashcardStudyProgress',
    props: {
        cards: { type: Array, required: true },
        currentIndex: { type: Number, default: 0 },
        isFullscreen: { type: Boolean, default: false },
        ratings: { type: Object, default: () => ({}) },
    },
    methods: {
        /**
         * Resolves the visual state class for a progress dot: the current card takes the accent
         * color; otherwise the per-session rating tints it green/red, falling back to the neutral
         * border color when the card has not been assessed yet.
         * @param {{id: string}} card - Flashcard the dot represents
         * @param {number} index - Position of the dot in the study set
         * @returns {string} Tailwind/state class for the dot
         */
        dotClass(card, index) {
            if (index === this.currentIndex) return 'bg-theme-accent';
            const rating = this.ratings[card.id];
            if (rating === 'know') return 'study-dot--know';
            if (rating === 'dontKnow') return 'study-dot--dont-know';
            return 'bg-theme-border';
        },
    },
};
</script>

<style scoped>
/* Semantic self-assessment colors are centralized in _theme_ui.scss (--flashcard-*),
   so the green/red stays consistent across dots, score bar, pips and rate buttons. */
.study-dot--know {
    background: var(--flashcard-known);
}

.study-dot--dont-know {
    background: var(--flashcard-unknown);
}
</style>
